import {identity, split, sortBy, isArray} from 'helpers';

export function toggle(list: string | string[], value: string, {separator = ',', min = 0, max = 9999, sort = identity} = {}) {
  let array = isArray(list) ? [...list] : split(list, separator).filter(notEmptyString);
  if (!array.includes(value)) {
    array = array.slice(0, max - 1);
    array.push(value);
  } else if (array.length > min) {
    array = array.filter(item => item !== value);
  }
  if (isArray(list)) {
    return array;
  }
  return sortBy(array, sort).join(separator);
}

function notEmptyString(value: string) {
  return value !== '';
}
